module.exports = __webpack_public_path__ + "img/12.98b9fbe2.jpg";